import Icon from '../components/Icon.vue'

Icon.register({"laptop":{"width":1920,"height":1792,"paths":[{"d":"M416 1280q-66 0-113-47t-47-113v-704q0-66 47-113t113-47h1088q66 0 113 47t47 113v704q0 66-47 113t-113 47h-1088zM384 416v704q0 13 9.5 22.5t22.5 9.5h1088q13 0 22.5-9.5t9.5-22.5v-704q0-13-9.5-22.5t-22.5-9.5h-1088q-13 0-22.5 9.5t-9.5 22.5zM1760 1344h160v96q0 40-47 68t-113 28h-1600q-66 0-113-28t-47-68v-96h160 1600zM1040 1440q16 0 16-16t-16-16h-160q-16 0-16 16t16 16h160z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/laptop.js
// module id = 1517
// module chunks = 0